import { getVideoProjectionSnapshot, videoProjectionAdapter, } from './videoProjectionAdapter.js';
export { DefaultVideoDataProvider } from './DefaultVideoDataProvider.js';
export { createDefaultVideoRenderPaths, createVideoRenderPathResolver, } from './VideoRenderPathResolver.js';
export const videoProjection = {
    adapter: videoProjectionAdapter,
    getSnapshot: getVideoProjectionSnapshot,
};
export { default } from './VideoViewport.js';
